import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  message: "",
};

export const SessionConflictSlice = createSlice({
  name: "SessionConflict",
  initialState,
  reducers: {
    openSessionConflict: (state, action) => {
      state.open = true;
      state.message = action?.payload?.message || "";
    },
    closeSessionConflict: (state) => {
      state.open = false;
      state.message = "";
    },
  },
});

export const { openSessionConflict, closeSessionConflict } =
  SessionConflictSlice.actions;

export default SessionConflictSlice.reducer;
